import i18n from "i18next";
import {initReactI18next} from "react-i18next";

const cmpLocaleBranch = window.ENV.REACT_APP_UI_LOCALES_BRANCH;
const lang = window.ENV.REACT_APP_LANG;

const processAllEscapeSequences = (obj) => {
    if (typeof obj === 'string') {
        try {
            // Wrap in quotes and use JSON.parse to handle all escape sequences
            return JSON.parse(`"${obj}"`);
        } catch (e) {
            // If JSON.parse fails, fall back to manual Unicode processing
            return obj.replace(/\\u([0-9a-fA-F]{4})/g, (match, hex) => {
                return String.fromCharCode(parseInt(hex, 16));
            });
        }
    } else if (Array.isArray(obj)) {
        return obj.map(processAllEscapeSequences);
    } else if (obj !== null && typeof obj === 'object') {
        const processed = {};
        for (const key in obj) {
            processed[key] = processAllEscapeSequences(obj[key]);
        }
        return processed;
    }
    return obj;
};

// Load and process resources
const enResources = require(`./locales/${cmpLocaleBranch}.en.json`);
const noResources = require(`./locales/${cmpLocaleBranch}.no.json`);

i18n.use(initReactI18next)
    .init({
      lng: lang,
      resources: {
        en: {
          common : processAllEscapeSequences(enResources)
        },
        no: {
          common: processAllEscapeSequences(noResources)
        }
      }
    });

i18n.languages = ['en', 'no'];
export default i18n;
